<div class="flex flex-col max-w-240 md:min-w-160 -m-6 rounded-lg">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 text-on-primary content-tittle">
        <div class="text-lg">Prestación Social</div>
        <button
            mat-icon-button
            (click)="dialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto p-4 pb-2 sm:p-4 overflow-y-auto contenedor-file max-heigth">
        <form [formGroup]="this.formPrestacion">
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>
                        Datos Beneficiario
                    </ng-template>
                    <lib-datos-beneficiario [form]="formPrestacion.get('datosTipoBeneficiario')" [cambioTipoBeneficiario]="cambioTipoBeneficiario"></lib-datos-beneficiario>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        Datos Localización
                    </ng-template>
                    <lib-datos-localizacion [form]="formPrestacion.get('datosLocalizacion')"></lib-datos-localizacion>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        Datos Programa
                    </ng-template>
                    <lib-datos-programa [form]="formPrestacion.get('datosPrograma')"></lib-datos-programa>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        Datos Entrega
                    </ng-template>
                    <lib-datos-entrega [form]="formPrestacion.get('datosEntrega')"></lib-datos-entrega>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        Datos Georeferencia
                    </ng-template>
                    <lib-datos-georeferencia [form]="formPrestacion.get('datosGeoreferencia')"></lib-datos-georeferencia>
                </mat-tab>
            </mat-tab-group>
        </form>
    </div>
    <div class="flex flex-row p-6 sm:p-8 justify-end items-end content-end">
        <button mat-raised-button (click)="dialogRef.close()" class="flex cancel-evk-button mr-3">
            Cerrar
        </button>
        <button [disabled]="!getFormValidationErrors()" (click)="save()" *ngIf="!readOnly"
                class="evk-button"
                [ngClass]="{'disabled-evk-cuu': !getFormValidationErrors()}">
            Guardar
        </button>
    </div>
</div>



